import React from "react";
import { CustomerReviews, RatingCount } from "~/common/Reviews/reviewModels";
import ReviewsOverview from "~/common/Reviews/ReviewsOverview";

interface Props {
  reviews: CustomerReviews;
  ratingDistribution: RatingCount[];
  totalRatings: number;
  itemNumber: string;
}

const ProductReviewsRating = ({ reviews, itemNumber }: Props) => {
  return (
    <div itemProp="aggregateRating">
      <ReviewsOverview
        reviews={reviews}
        itemNumber={itemNumber}
        isProductReviewPage
      />
    </div>
  );
};

export default ProductReviewsRating;
